import './FoundingBadge.css';

/**
 * The founding-member mark: a small scalloped seal with a white check, the way
 * Instagram sits a verified tick next to a handle. It fills with the active
 * accent (per-user pick or the global brand accent), so it reads as a brand
 * set-piece rather than a generic blue tick. Used inline after a handle - in
 * comments (replacing the old chunky "FOUNDING" pill) and on the profile card
 * (alongside the fuller "Founding Member" tag).
 */

// Scalloped seal outline, generated once at module load: alternating
// outer/inner radii around a 24x24 box give the petalled "official seal" edge.
const SEAL_PATH = (() => {
  const cx = 12, cy = 12, bumps = 11, steps = bumps * 2;
  let d = '';
  for (let i = 0; i <= steps; i++) {
    const r = i % 2 === 0 ? 11.5 : 9.4;
    const a = (Math.PI * 2 * i) / steps - Math.PI / 2;
    const x = cx + r * Math.cos(a);
    const y = cy + r * Math.sin(a);
    d += `${i === 0 ? 'M' : 'L'}${x.toFixed(2)} ${y.toFixed(2)}`;
  }
  return `${d}Z`;
})();

export function FoundingBadge({ size = 14, className = '' }: { size?: number; className?: string }) {
  return (
    <svg
      className={`founding-badge ${className}`.trim()}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      role="img"
      aria-label="Founding member"
    >
      <title>Founding member</title>
      <path d={SEAL_PATH} fill="currentColor" />
      <path
        d="M7.6 12.3l2.9 2.9 5.9-6"
        fill="none"
        stroke="var(--accent-ink, #fff)"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
